export default "__VITE_ASSET__Bxigxb39__"